export default __webpack_public_path__ + "static/media/shutterstock.d9a2c026.webp";